var render = function (_h,_vm) {var _c=_vm._c;return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('p',[_c('span',[_vm._v("Copyright ©")]),_c('span',[_vm._v(_vm._s(new Date().getFullYear())+" ")]),_c('a',{attrs:{"href":"https://cruu.io","target":"_blank","rel":"nofollow"}},[_vm._v("Cruu")])])])}
var staticRenderFns = []

export { render, staticRenderFns }